module.exports = __webpack_public_path__ + "static/body-bdcf78b551396d430b16a0f4144fa7cd.png";